<!-- pr-approve-reject-page.component.html -->

<div class="custom-margin">
  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="text-center mt-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2">Loading PR details...</p>
  </div>

  <!-- Main Content -->
  <section class="section-card" *ngIf="!isLoading && prData.pr_id">
    <!-- Header -->
    <div class="row">
      <div class="col-md-12">
        <div class="headingPara">
          <h5>#{{prData.prCode}}</h5>
          <span class="badge copexOpexButtons">{{prData.type || prData.prType}}</span>
          <!-- ✅ View Only Badge Removed -->
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="prArea">
      <div class="row">
        <!-- Left Section - PR Details -->
        <div class="col-md-9">
          <div class="card custom-card">
            <div class="card-body statusArea">
              <!-- Status Row -->
              <div class="row">
                <div class="col-md-4">
                  <p class="fw-bold statusPr">Status</p>
                  <span class="badge" [ngClass]="{
                    'bg-warning': prData.prCategoryStatus === 'Pending',
                    'bg-success': prData.prCategoryStatus === 'Approved',
                    'bg-danger': prData.prCategoryStatus === 'Rejected'
                  }">{{prData.prCategoryStatus}}</span>
                </div>
                <div class="col-md-4">
                  <p class="fw-bold statusPr">Created Date</p>
                  <p class="mb-0" style="font-size: 14px; color: #566f9e;">
                    {{prData.createdAt | date:"MMM dd, yyyy"}}
                  </p>
                </div>
                <div class="col-md-4">
                  <p class="fw-bold statusPr">Department/Project</p>
                  <p class="mb-0" style="font-size: 14px; color: #566f9e;">
                    {{prData.prTypeFor}}
                  </p>
                </div>
              </div>

              <!-- Details Row -->
              <div class="row mt-4">
                <div class="col-md-4">
                  <p class="fw-bold statusPrArea">Created By</p>
                  <p class="mb-0" style="font-size: 14px; color: #566f9e;">
                    {{prData.empName}}
                  </p>
                </div>
                <div class="col-md-4">
                  <p class="fw-bold statusPrArea">Type</p>
                  <p class="mb-0" style="font-size: 14px; color: #566f9e;">
                    {{prData.prType}}
                  </p>
                </div>
                <div class="col-md-4">
                  <p class="fw-bold statusPrArea">Budget Left</p>
                  <p class="mb-0" style="font-size: 14px; color: #566f9e;">
                    {{budget.remainingAmount}}
                  </p>
                </div>
              </div>

              <!-- Priority & Branch -->
              <div class="row mt-4">
                <div class="col-md-3">
                  <p class="fw-bold statusPrArea">Priority</p>
                  <span class="badge" [ngClass]="{
                    'bg-danger': prior === 'High',
                    'bg-warning': prior === 'Medium',
                    'bg-info': prior === 'Low'
                  }">{{prior}}</span>
                </div>
                <div class="col-md-4">
                  <p class="fw-bold statusPrArea">Branch</p>
                  <p style="font-size: 14px; color: #566f9e;">
                    {{prData.companyBranchName}}
                  </p>
                </div>
              </div>

              <!-- Approval Workflow -->
              <div class="row mt-3" *ngIf="prData.tbl_prWorkFlowApproves?.length > 0">
                <article class="inner-box-header">
                  <div 
                    *ngFor="let item of prData.tbl_prWorkFlowApproves; let i = index"
                    class="dynamic-border-wrapper" 
                    [ngClass]="[
                      item.progressStatus === 'Open' || item.progressStatus === 'Pending' ? 'pending' : '',
                      item.progressStatus === 'Approved' ? 'approved' : '',
                      item.progressStatus === 'Reject' || item.progressStatus === 'Rejected' ? 'rejected' : ''
                    ]" 
                    style="width:50%;">
                    <ul class="quotations-steps">
                      <li>
                        <span 
                          class="material-icons"
                          [ngStyle]="{'color': getStatusColor(item.progressStatus), 'font-size': '30px'}"
                          (click)="showRemark(item)" 
                          (mouseenter)="onMouseEnter(item)"
                          (mouseleave)="onMouseLeave()">
                          {{ open(item.progressStatus) }}
                        </span>
                        <p><strong>{{ item.empName }}</strong></p>
                        <p>{{ item.updatedAt | date:'dd/MM/yyyy' }}</p>
                        <div class="remark">
                          {{ item.empRemark || 'No remarks' }}
                        </div>
                      </li>
                    </ul>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>

        <!-- ✅ Right Section - Action Buttons (Always Enabled) -->
        <div class="col-md-3 mt-4">
          <div class="row">
            <!-- ✅ Removed [disabled]="isReadOnly" -->
            <button 
              type="button" 
              class="copybtnpurchase" 
              (click)="save()">
              Approve Purchase Request
            </button>
            
            <!-- ✅ Removed [disabled]="isReadOnly" -->
            <button 
              type="button" 
              class="editPurchaseReq" 
              (click)="saveRejectPR()">
              Reject Purchase Request
            </button>
            
            <textarea 
              name="remark" 
              id="remark" 
              cols="30" 
              rows="4" 
              class="allButtonTextarea form-control"
              [(ngModel)]="pendingApprove.empRemark"
              placeholder="Enter remark for rejection...">
            </textarea>
            
            <div class="downloadOptopnbtn" *ngIf="prData.tbl_prFileUploads?.[0]?.prFileUpload">                                
              <p class="mb-2">Download Option</p>
              <a [href]="prData.tbl_prFileUploads[0].prFileUpload" target="_blank">
                <button type="button" class="downloadArea">
                  Download File <span class="material-icons downloadIconss">download</span>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- PR Remark -->
      <div class="mt-4" *ngIf="prData.remark">
        <textarea 
          class="allButtonTextarea form-control" 
          name="prRemark" 
          id="prRemark" 
          cols="60" 
          rows="4" 
          style="width: 74.8%;"
          readonly>{{prData.remark}}</textarea>
      </div>
    </div>

    <!-- ==================== ITEMS TABLE ==================== -->
    <div class="row mt-3" *ngIf="prData.prCategory === 'Item PR' && prData.tbl_prItemMappings?.length > 0">
      <div class="form-group">
        <table class="table table-bordered border-dark">
          <thead>
            <tr>
              <th style="width: 5%;">
                <!-- ✅ Removed [disabled]="isReadOnly" -->
                <input 
                  type="checkbox"
                  [checked]="isselected"
                  (change)="selectAllItem()"
                  class="form-check-input"
                  style="height: 20px; width: 20px;">
              </th>
              <th>Item Name</th>
              <th>UOM</th>
              <th>PR Qty</th>
              <th>Approve Qty</th>
              <th>Reject Qty</th>
              <th>Item value</th>
            </tr>
          </thead>
          
          <!-- Item Type -->
          <tbody *ngIf="prData.prType === 'Item'">
            <tr *ngFor="let item of prData.tbl_prItemMappings; let i = index">
              <td>
                <!-- ✅ Removed [disabled]="isReadOnly" -->
                <input 
                  type="checkbox" 
                  [(ngModel)]="item.isSelected" 
                  (change)="onItemCheckboxChange(item, i, $event)"
                  class="form-check-input" 
                  style="height: 20px; width: 20px;">
              </td>
              <td>
                <input 
                  type="text" 
                  class="form-control"
                  [(ngModel)]="item.itemName" 
                  readonly>
              </td>
              <td>
                <input type="text" class="form-control" [(ngModel)]="item.uomName" readonly>
              </td>
              <td>
                <input type="text" class="form-control" [(ngModel)]="item.quantity" readonly>
              </td>
              <td>
                <!-- ✅ Removed [readonly]="isReadOnly" -->
                <input 
                  type="number" 
                  (input)="totalCost(item.mVP, item.approveQuantity, item.quantity, i)"
                  class="form-control" 
                  [(ngModel)]="item.approveQuantity"
                  min="0"
                  [max]="item.quantity">
                <div *ngIf="item.approveQuantity > item.quantity" class="text-danger small">
                  Cannot exceed PR Qty ({{ item.quantity }})
                </div>
              </td>
              <td>
                <input 
                  type="text" 
                  class="form-control" 
                  [(ngModel)]="item.rejectQuantity"
                  readonly>
              </td>
              <td>
                <input type="text" class="form-control" [(ngModel)]="item.total" readonly>
              </td>
            </tr>
          </tbody>

          <!-- BOM Type -->
          <tbody *ngIf="prData.prType === 'BOM'">
            <tr *ngFor="let item of prData.tbl_prBOMMappings; let i = index">
              <td>
                <!-- ✅ Removed [disabled]="isReadOnly" -->
                <input 
                  type="checkbox" 
                  [(ngModel)]="item.isSelected"
                  (change)="toggleBomCheckbox(item, i)" 
                  class="form-check-input" 
                  style="height: 20px; width: 20px;">
              </td>
              <td>
                <input 
                  type="text" 
                  class="form-control"
                  [(ngModel)]="item.productName" 
                  readonly>
              </td>
              <td>
                <input type="text" class="form-control" [(ngModel)]="item.uomName" readonly>
              </td>
              <td>
                <input type="text" class="form-control" [(ngModel)]="item.quantity" readonly>
              </td>
              <td>
                <!-- ✅ Removed [readonly]="isReadOnly" -->
                <input 
                  type="number" 
                  (input)="totalCostBom(item.mVP, item.approveQuantity, item.quantity, i)"
                  class="form-control" 
                  [(ngModel)]="item.approveQuantity"
                  min="0"
                  [max]="item.quantity">
                <div *ngIf="item.approveQuantity > item.quantity" class="text-danger small">
                  Cannot exceed PR Qty ({{ item.quantity }})
                </div>
              </td>
              <td>
                <input 
                  type="text" 
                  class="form-control" 
                  [(ngModel)]="item.rejectQuantity"
                  readonly>
              </td>
              <td>
                <input type="text" class="form-control" [(ngModel)]="item.total" readonly>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ==================== SERVICE TABLE ==================== -->
    <div class="row mt-5" *ngIf="prData.prCategory === 'Service PR' && prData.tbl_prServiceMappings?.length > 0">
      <div class="form-group">
        <table class="table table-bordered border-dark">
          <thead>
            <tr>
              <th style="width: 5%;">
                <!-- ✅ Removed [disabled]="isReadOnly" -->
                <input 
                  type="checkbox" 
                  (change)="SelectServiceItem()" 
                  [(ngModel)]="isSelected"
                  class="form-check-input" 
                  style="height: 20px; width: 20px;">
              </th>
              <th>Service Name</th>
              <th>Service Code</th>
              <th>Service Description</th>
              <th>Frequency</th>
              <th>No. of Frequencies</th>
              <th>Service Price</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of prData.tbl_prServiceMappings; let i = index">
              <td>
                <!-- ✅ Removed [disabled]="isReadOnly" -->
                <input 
                  type="checkbox" 
                  [(ngModel)]="item.isSelected"
                  (change)="toggleServiceCheckbox(item, i)" 
                  class="form-check-input" 
                  style="height: 20px; width: 20px;">
              </td>
              <td>
                <input type="text" class="form-control" [(ngModel)]="item.serviceName" readonly>
              </td>
              <td>
                <input type="text" class="form-control" [(ngModel)]="item.serviceCode" readonly>
              </td>
              <td>
                <input type="text" class="form-control" [(ngModel)]="item.serviceDescription" readonly>
              </td>
              <td>
                <input type="text" class="form-control" [(ngModel)]="item.Frequency" readonly>
              </td>
              <td>
                <input type="text" class="form-control" [(ngModel)]="item.quantity" readonly>
              </td>
              <td>
                <input type="text" class="form-control" [(ngModel)]="item.mVP" readonly>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Back Button -->
    <div class="d-flex justify-content-between backNextButton mt-4">
      <button routerLink="/admin/purchase/pending-for-approve" class="backButton">
        <i class="fa-solid fa-arrow-left"></i>&nbsp;<span> Back</span>
      </button>
    </div>
  </section>
</div>